import { ECONOMIC_CALENDAR_STORAGE_KEYS } from "@/lib/localStorageKeys/economic-calendar";

export type MonthVersionMap = Record<string, string>;

export function loadMonthVersions(): MonthVersionMap {
  if (typeof window === "undefined") return {};

  try {
    const raw = localStorage.getItem(
      ECONOMIC_CALENDAR_STORAGE_KEYS.MONTH_VERSIONS
    );
    if (!raw) return {};
    const parsed = JSON.parse(raw) as unknown;
    if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) return {};
    return parsed as MonthVersionMap;
  } catch {
    return {};
  }
}

export function saveMonthVersions(versions: MonthVersionMap): void {
  if (typeof window === "undefined") return;

  try {
    localStorage.setItem(
      ECONOMIC_CALENDAR_STORAGE_KEYS.MONTH_VERSIONS,
      JSON.stringify(versions)
    );
  } catch (error) {
    console.error("[EconomicCalendar] Failed to save month versions:", error);
  }
}

export function mergeMonthVersions(
  existing: MonthVersionMap,
  incoming: Array<{ monthKey: string; versionHash: string }>
): MonthVersionMap {
  const next = { ...existing };
  for (const item of incoming) {
    const key = item.monthKey?.trim();
    const hash = item.versionHash?.trim();
    if (!key || !hash) continue;
    next[key] = hash;
  }
  return next;
}
